module.exports = __webpack_public_path__ + "static/usloviya_otkrytiya_vklada_fl_archive-2506bed8600c7215fbade98564971287.pdf";